import styled, { css } from "styled-components";

const InboxFilterItem = styled.div<{ active?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 4px;
  padding: 6px 8px;
  border-radius: 8px;
  font-weight: 400;
  gap: 8px;
  cursor: pointer;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;

  &:hover {
    background-color: #f8f8f7;
  }

  i {
    font-size: 15px;
  }

  svg {
    width: 15px;
    height: 15px;
  }

  ${props => props.active && css`
    color: rgb(227, 87, 18);

    svg {
      fill: rgb(227, 87, 18);
      color: rgb(227, 87, 18);
    }
  `}
`

export default InboxFilterItem